import {
  deleteApiCaller,
  getApiCaller,
  patchApiCaller,
  postApiCaller,
  postFormDataApiCaller,
  putFormDataApiCaller,
} from "../apiCaller";

export const getSectionsOfHome = async ({ currentPage = 1, limit = 10 } = {}) => {
  const response = await getApiCaller(
    `advertisement/get-all?page=${currentPage}&limit=${limit}`
  );
  return response;
};

export const addSectionOfHome = async (payload = {}) => {
  // Check if payload is already FormData
  if (payload instanceof FormData) {
    const response = await postFormDataApiCaller("advertisement/create", payload);
    return response;
  }

  // Convert payload to FormData
  const formData = new FormData();

  formData.append('title', payload.title || '');
  formData.append('description', payload.description || '');
  formData.append('link', payload.link || '');
  formData.append('sequence', payload.sequence || '0');

  if (payload.image) {
    formData.append('image', payload.image);
  }

  const response = await postFormDataApiCaller("homeSection/create", formData);
  return response;
};

export const updateSectionOfHome = async (id, payload = {}) => {
  // Check if payload is already FormData
  if (payload instanceof FormData) {
    const response = await putFormDataApiCaller(`advertisement/${id}`, payload);
    return response;
  }

  // Convert payload to FormData
  const formData = new FormData();

  formData.append('title', payload.title || '');
  formData.append('description', payload.description || '');
  formData.append('link', payload.link || '');
  formData.append('sequence', payload.sequence || '0');

  if (payload.image) {
    formData.append('image', payload.image);
  }

  const response = await putFormDataApiCaller(`homeSection/${id}`, formData);
  return response;
};

export const deleteSectionOfHome = async (id) => {
  const response = await deleteApiCaller(`advertisement/${id}`);
  return response;
};

export const updateSectionSequence = async (id, sequence) => {
  const response = await patchApiCaller("advertisement/update-sequence", { id, sequence });
  return response;
};

// YouTube Playlist Import
export const previewYouTubePlaylist = async (payload = {}) => {
  const response = await postApiCaller("advertisement/preview-playlist", payload);
  return response;
};

export const importYouTubePlaylist = async (payload = {}) => {
  const response = await postApiCaller("advertisement/import-playlist", payload);
  return response;
};
